import React from 'react';
import { Wifi } from 'lucide-react';

const IoTDeviceManagement = React.lazy(() => import('@/domains/iot/pages/IoTDeviceManagement'));

export default function IoTDashboard() {
  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center gap-3">
        <Wifi className="w-8 h-8 text-blue-600" />
        <div>
          <h1 className="text-2xl font-bold text-gray-900">IoT Device Management</h1>
          <p className="text-gray-500">Monitor and manage connected IoT devices, sensors, and data streams</p>
        </div>
      </div>
      <React.Suspense fallback={<div className="flex items-center justify-center h-64"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div></div>}>
        <IoTDeviceManagement />
      </React.Suspense>
    </div>
  );
}
